import { useEffect, useState } from 'react';

import { API_URL } from '../config';
import { Copy, Lang } from '../i18n';
import { createSession } from '../auth/session';
import type { TelegramWebAppUser } from '../auth/verifyInitData';
import { webApp } from '../telegram/webapp';

export interface SessionState {
  status: 'idle' | 'ok' | 'unverified' | 'fail' | 'outside';
  user: TelegramWebAppUser | null;
  token: string | null;
  lang: Lang;
}

export function useTelegramSession(langFromUnsafe: Lang): SessionState {
  const [state, setState] = useState<SessionState>({
    status: 'idle',
    user: webApp()?.initDataUnsafe.user ?? null,
    lang: langFromUnsafe,
    token: null,
  });

  useEffect(() => {
    const app = webApp();
    if (!app?.initData) {
      setState((prev) => ({ ...prev, status: 'outside' }));
      return;
    }
    void createSession(app.initData, API_URL)
      .then((result) => {
        const user = result.user ?? app.initDataUnsafe.user ?? null;
        setState({
          status: result.unverified ? 'unverified' : result.ok ? 'ok' : 'fail',
          user,
          lang: langFromUnsafe,
          token: result.session,
        });
      })
      .catch(() => {
        setState({
          status: 'fail',
          user: app.initDataUnsafe.user ?? null,
          lang: langFromUnsafe,
          token: null,
        });
      });
  }, [langFromUnsafe]);

  return state;
}
